// Simple function to normalize question text for better matching
export const normalizeQuestion = (text: string): string => {
  return text
    .toLowerCase()
    .replace(/[^\w\s\d]/g, '')  // Remove punctuation but keep numbers
    .replace(/\s+/g, ' ')       // Replace multiple spaces with single space
    .trim();                    // Trim leading/trailing spaces
};

// Check if a question should be excluded from caching (too context-dependent)
export const shouldExcludeFromCache = (normalizedQuestion: string): boolean => {
  const excludePatterns = [
    /^(what did you say|repeat that|can you repeat|say that again)/,
    /^(what|huh|excuse me|pardon|sorry)/,
    /^(clarify|explain that|what do you mean)/,
    /^(that|it|this)/,
    /^(yes|no|ok|okay|sure)$/
  ];
  
  return excludePatterns.some(pattern => pattern.test(normalizedQuestion));
};